import {useCallback, useEffect, useState} from "react";

export const useCountdownTime = () => {
    const [times, setTimes] = useState(180);
    const [idInterval, setId] = useState();
    const start = useCallback(() => {
        let i = 180;
        const id = setInterval(() => {
            if (i > 0) {
                i = i - 1;
                setTimes(i)
            } else {
                clearInterval(id);
            }
        }, 1000);
        setId(id)
    }, [])
    const restart = () => {
        clearInterval(idInterval);
        setTimes(180);
        start()
    }
    return [times, start, restart]
}